export default __webpack_public_path__ + "static/media/Prancheta BAT.ae02635a.svg";